<template>
  <div>
    <el-tabs v-model="active" type="border-card">
      <el-tab-pane label="在途运单" name="transit" lazy>
        <TransitTable />
      </el-tab-pane>
      <el-tab-pane label="待提货" name="pick" lazy>
        <ToPickTable />
      </el-tab-pane>
      <el-tab-pane label="待送达" name="to-delivery" lazy>
        <DeliveryTable />
      </el-tab-pane>
      <el-tab-pane label="待回单" name="to-pod" lazy>
        <ToPodTable />
      </el-tab-pane>
      <el-tab-pane label="异常事件" name="abnormal" lazy>
        <AbnormalTable />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import TransitTable from './components/transit-table'
import ToPickTable from './components/to-pick-table'
import DeliveryTable from './components/to-delivery-table'
import ToPodTable from './components/to-pod-table'
import AbnormalTable from './components/abnormal-table'
import BaseTable from '@/mixins/base-table'
export default {
  name: 'carriage-tracking',
  mixins: [BaseTable],
  components: {
    TransitTable,
    ToPickTable,
    DeliveryTable,
    ToPodTable,
    AbnormalTable,
  },
  data() {
    return {
      active: 'transit',
    }
  },
  computed: {
    routeActive() {
      return this.$route.params.active
    },
  },
  watch: {
    routeActive: {
      handler(value) {
        if (!value) return
        this.active = value
      },
      immediate: true,
    },
  },
}
</script>
